/* cs-product-card.js — quick-add, variant switching, image hover */
(function () {
  if (window._csProductCardInit) return;
  window._csProductCardInit = true;

  /* ─── cart helper ────────────────────────────────────────────────── */
  function addToCart(variantId, onSuccess, onError, onFinally, skipDrawer) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        return r.ok ? r.json() : r.json().then(function (e) { throw e; });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount: cart.item_count, source: 'cs-product-card' } }
        }));
        if (!skipDrawer) {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }
        if (onSuccess) onSuccess(cart);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        if (onError) onError(err);
      })
      .finally(function () {
        if (onFinally) onFinally();
      });
  }

  /* ─── close all open pickers ─────────────────────────────────────── */
  function closeAllPickers(except) {
    document.querySelectorAll('.pc-quickadd.is-open').forEach(function (p) {
      if (p !== except) {
        p.setAttribute('aria-hidden', 'true');
        p.classList.remove('is-open');
      }
    });
  }

  /* ─── delegated click handler ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {

    /* 1. Quick-add "+" button */
    var addBtn = e.target.closest('.add-to-cart-btn');
    if (addBtn) {
      var hasVariants = addBtn.dataset.hasVariants === 'true';
      var inSearchModal = !!addBtn.closest('#search-modal');
      var card = addBtn.closest('.cs-product');
      var picker = card && card.querySelector('.pc-quickadd');

      if (hasVariants && picker) {
        /* Open variant picker when one exists in the card */
        closeAllPickers(picker);
        picker.setAttribute('aria-hidden', 'false');
        picker.classList.add('is-open');
      } else {
        /* Single variant, or multi-variant with inline selection (no picker) — add directly */
        var variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        addBtn.classList.add('rik-atc--loading');
        addToCart(
          variantId,
          function () {
            if (inSearchModal) {
              window.location.href = '/cart';
            } else {
              addBtn.classList.add('rik-atc--added');
              setTimeout(function () { addBtn.classList.remove('rik-atc--added'); }, 1500);
            }
          },
          null,
          function () {
            addBtn.disabled = false;
            addBtn.classList.remove('rik-atc--loading');
          },
          inSearchModal
        );
      }
      return;
    }

    /* 2. Variant option button inside picker */
    var optBtn = e.target.closest('.pc-quickadd__opt');
    if (optBtn && !optBtn.disabled) {
      var picker = optBtn.closest('.pc-quickadd');
      picker.querySelectorAll('.pc-quickadd__opt').forEach(function (b) { b.classList.remove('is-active'); });
      optBtn.classList.add('is-active');
      var atcBtn = picker.querySelector('.pc-quickadd__atc');
      if (atcBtn) atcBtn.dataset.variantId = optBtn.dataset.id;
      return;
    }

    /* 3. "Add to cart" button inside picker */
    var pickerAtc = e.target.closest('.pc-quickadd__atc');
    if (pickerAtc) {
      var vid = pickerAtc.dataset.variantId;
      if (!vid) return;
      var pickerEl         = pickerAtc.closest('.pc-quickadd');
      var originalLabel    = pickerAtc.textContent;
      var pickerInModal    = !!pickerAtc.closest('#search-modal');
      pickerAtc.disabled   = true;
      pickerAtc.textContent = 'Adding…';
      addToCart(
        vid,
        function () {
          if (pickerInModal) {
            window.location.href = '/cart';
          } else {
            pickerEl.setAttribute('aria-hidden', 'true');
            pickerEl.classList.remove('is-open');
          }
        },
        null,
        function () {
          pickerAtc.disabled    = false;
          pickerAtc.textContent = originalLabel;
        },
        pickerInModal
      );
      return;
    }

    /* 4. Close button inside picker */
    var closeBtn = e.target.closest('.pc-quickadd__close');
    if (closeBtn) {
      var p = closeBtn.closest('.pc-quickadd');
      p.setAttribute('aria-hidden', 'true');
      p.classList.remove('is-open');
      return;
    }

    /* 5. Variant buttons in the card info area */
    var varBtn = e.target.closest('.variant-btn');
    if (varBtn) {
      var card = varBtn.closest('.cs-product');
      if (!card) return;

      card.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      varBtn.classList.add('active');

      var img = card.querySelector('.main-image');
      if (img && varBtn.dataset.image) img.src = varBtn.dataset.image;

      var priceEl = card.querySelector('.pp-prices .price');
      if (priceEl && varBtn.dataset.price) priceEl.textContent = varBtn.dataset.price;

      var compareEl = card.querySelector('.compare-price s');
      if (compareEl && varBtn.dataset.compare) compareEl.textContent = varBtn.dataset.compare;

      var mainAddBtn = card.querySelector('.add-to-cart-btn');
      if (mainAddBtn && varBtn.dataset.id) mainAddBtn.dataset.variantId = varBtn.dataset.id;

      var pricesWrapper = card.querySelector('.pp-prices');
      if (pricesWrapper) {
        var hasCmp = !!(varBtn.dataset.compare && varBtn.dataset.compare !== varBtn.dataset.price);
        pricesWrapper.classList.toggle('compare-available', hasCmp);
      }
      return;
    }

    /* 6. Click outside any open picker — close all */
    if (!e.target.closest('.pc-quickadd') && !e.target.closest('.add-to-cart-btn')) {
      closeAllPickers(null);
    }
  });

  /* ─── close picker on Escape key ─────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPickers(null);
  });

})();
